export default __webpack_public_path__ + "static/media/Laboratorioambiente.d9d1d0e7.png";